<div [formGroup]="paymentElementForm">
  <mat-dialog-content class="mat-typography">

    <!-- Loader overlay -->
    <div *ngIf="!isElementLoaded" class="overlay-loader">
      <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    </div>

    <!-- Stripe Elements -->
    <ngx-stripe-elements
      [stripe]="stripe"
      [elementsOptions]="elementsOptions"
    >
      <ngx-stripe-payment
        [options]="paymentElementOptions"
        (ready)="onElementReady()">
      </ngx-stripe-payment>
    </ngx-stripe-elements>
  </mat-dialog-content>  

  <!-- Dialog actions only after Stripe element is loaded -->
  <mat-dialog-actions align="end" *ngIf="isElementLoaded">
    <div mat-dialog-actions>
      <button class="cancel-popup" mat-stroked-button mat-dialog-close>
        Cancel
      </button>
      <button class="popup-save" mat-flat-button
        [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
        (click)="addPaymentMethod()"
        [disabled]="new_payment_method_is_loading">
        Add New Credit Card
      </button>
    </div>
  </mat-dialog-actions>
</div>
